import { config } from "../config";
import axios from 'axios';


export function invokePostService(path: any, reqData = {}, token: any) {
  // const newtoken = localStorage.getItem("token") || "";

  return new Promise(async (resolve, reject) => {

    await axios({
      method: `POST`,
      url: `${config.prapp.basURL}${path}`,
      headers: {
        'Content-Type': 'application/json',
        'authorization': `Bearer ${token}`
      },
      data: reqData,
    }).then((response) => {
      resolve(response);
    }).catch((err) => {
      handleErrorResponse(err); 
      reject(err);
    });
  });
};

export function invokeGetService(path: any, reqData = {}, params = {}, token: any, skiptoken: boolean=false) {
  // const newtoken = localStorage.getItem("token") || "";
  
 
  return new Promise(async (resolve, reject) => {
    var headers = {};
    if(skiptoken){
       headers = {
        'Content-Type': 'application/json'
      }    
    }
    else{
       headers = {
        'Content-Type': 'application/json',
        'authorization': `Bearer ${token}`
      }
    }
    await axios({
      method: `GET`,
      url: `${config.prapp.basURL}${path}`,
      headers: {
        'Content-Type': 'application/json',
        'authorization': `Bearer ${token}`

      },
      data: reqData,
      params: params,
    }).then((response) => {
      resolve(response);
    }).catch((err) => {
      handleErrorResponse(err); 
      reject(err);
    });
  });
};

export function invokeDeleteService(path: any, reqData = {}, token: any) {
  return new Promise(async (resolve, reject) => {
    await axios({
      method: 'DELETE',
      url: `${config.prapp.basURL}${path}`,
      headers: {
        'Content-Type': 'application/json',
        'authorization': `Bearer ${token}`
      },
      data: reqData,
    }).then((response) => {
      resolve(response);
    }).catch((err) => {
      handleErrorResponse(err);
      reject(err);
    });
  });
}

function handleErrorResponse(err:any) {
  if (err.response && err.response.status === 401 && err.response.data === "TokenExpiredError") { 
    localStorage.clear();
    // Remove the 'token' item from local storage
    localStorage.removeItem('token');
    window.location.href = "/login";
  }
}